module.exports = __webpack_public_path__ + "937e0a2be4457bdd6909b04cd1adb0a1.pdf";